// import './VendorDashboardRawSpacesTab.scss';

import * as React from 'react';
import { Button, Modal, notification } from 'antd';

import { Album } from '../../../interfaces/album.interface';
import AlbumApi from '../../../api-services/album-api.service';
import TabSideMenu from '../../ui-components/tab-side-menu/TabSideMenu';
import AlbumCard from '../../basic-components/album-card/AlbumCard';



interface VendorDashboardRawSpacesTabProps {

}


interface VendorDashboardRawSpacesTabState {
  currentSelection: number;
  loadingAlbums: boolean;
  albums: Album[];
}




class VendorDashboardRawSpacesTab extends React.Component<VendorDashboardRawSpacesTabProps, VendorDashboardRawSpacesTabState> {

  albumApi = new AlbumApi;  

  navigations = [
    {id: "raw_spaces", type: "raw_space", label: "RAW SPACES"},
    // {id: "videos", type: "video", label: "VIDEOS"},
  ];
  
  selected = this.navigations[0];

  componentDidMount() {
    this.setState({
      currentSelection: 0
    });
    
    setTimeout(() => {
      this.getAlbums();
    }, 500);

  }
  
  
  addNewAlbum(): void {
    this.albumApi.createAlbum(this.selected?.type)
    .then(albumResponse => {
      window.location.href = `/business/dashboard/${this.selected.id}/${albumResponse.id}/edit`;
    })
  }


  getAlbums(): void {
    this.setState({ loadingAlbums: true });
    
    this.albumApi.getAlbums(this.selected.type)
    .then(albums => {
      this.setState({ albums: albums });
    })
    .catch(error => {
      notification.error({ message: `There\'s an error while loading the ${this.selected.id}.`, className: 'antd-mod center' })
    })
    .finally(() => {
      this.setState({ loadingAlbums: true });
    });
  }


  editAlbum(album: Album): void {
    window.location.href = `/business/dashboard/${this.selected.id}/${album.id}/edit`;
  }


  removeAlbum(albumId: number): void {
    this.albumApi.deleteAlbum(albumId)
      .then(albumResponse => {
        this.setState(prevState => ({
          albums: prevState.albums.filter(album => album.id !== albumId)
        }));
      })
  }


  handleSelectedMenu = (selected: any) => {
    this.setState({currentSelection: selected});
    this.selected = this.navigations[selected];
    
    setTimeout(() => {
      this.getAlbums();
    }, 500);
  }


  renderHeader() {
    return (
      <div className="header">
        <div className="title typo-title-2 typo-bold">
          RAW SPACES
        </div>
        <Button className="antd-mod add-new" onClick={() => { this.addNewAlbum() }} type="primary" size="large">Add New</Button>
      </div>
    );
  }



  renderAlbumsList() {
    return (
      <div className="albums-list">
        {this.state?.albums?.map(album => 
          <AlbumCard name="raw space" album={album} key={album.id} editClicked={(album) => { this.editAlbum(album) }} editable={true}
            removable={true} removeClicked={(albumId) => { this.removeAlbum(albumId) } }></AlbumCard>)
        }
      </div>
    );
  }
  
  
  render() {
    return (
      <div className="VendorDashboardRawSpacesTab">
        {/* <TabSideMenu navigations={this.navigations} onSelectMenu={this.handleSelectedMenu}/> */}

        <div className="tab-content">
          {this.renderHeader()}
          {this.renderAlbumsList()}
        </div>
      </div>
    );
  }
  
}





export default VendorDashboardRawSpacesTab;